import { CertificateStatusEnum } from "../../../common/enums/CertificateStatusEnum";
import refreshImage from "../../../common/images/refresh.svg";
import editWhiteImage from "../../../common/images/edit-white.svg";

export const getRenewButtonImage = (activeTab: string): string => {
    switch (activeTab) {
        case CertificateStatusEnum.EXPIRED:
            return refreshImage;
        case CertificateStatusEnum.REJECTED:
            return editWhiteImage;
        default:
            return "";
    }
};
